import { render, staticRenderFns } from "./StripeAuthorization.vue?vue&type=template&id=bb4d7ab6&scoped=true"
import script from "./StripeAuthorization.vue?vue&type=script&lang=js"
export * from "./StripeAuthorization.vue?vue&type=script&lang=js"
import style0 from "./StripeAuthorization.vue?vue&type=style&index=0&id=bb4d7ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4d7ab6",
  null
  
)

export default component.exports